module.exports = __webpack_public_path__ + "static/springkraf-logo-c835dd4d025459d32b1adf607c7008e5.png";